module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_11_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_11_after.jpg
// module id = 1155
// module chunks = 0